import styles from './Toast.module.css';
import globalStyles from '@/Global.module.css';

interface ToastSuccessProps {
	message?: string;
	successCount?: number;
	errorCount?: number;
}

export default function ToastSuccess({ message, successCount }: ToastSuccessProps) {
	return (
		<div className={globalStyles.bold}>
			<span>{message ?? 'Saved'}</span>

			{
				<div className={styles.feedback}>
					<span className={styles['feedback-success']}>Success: {successCount}</span>
				</div>
			}
		</div>
	);
}
